import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Skeleton } from "antd";

import "./Biochem.css";

class HmcTable extends Component {
  handleRowClick = (index) => {
    const { showHmcData, disable } = this.props;
    if (!disable) {
      showHmcData(index);
    }
  };

  addTableRow = (data, func) => {
    const { rowIndex, loading } = this.props;
    if (loading) {
      return (
        <tr className="HMCTable__Row">
          <td><Skeleton.Input active /></td>
        </tr>
      );
    }
    if (data.length === 0) {
      return (
        <tr className="HMCTable__Row">
          <td>No Data</td>
        </tr>
      );
    }
    return data.map((IDs, i) => {
      const { genista_id } = IDs;
      return (
        <tr key={i} className={rowIndex === i ? "HMCTable__Row HMCTable__Row--active" : "HMCTable__Row"} onClick={() => func(i)}>
          <td>{genista_id}</td>
        </tr>
      );
    });
  };

  render() {
    const { data } = this.props;
    return (
      <div>
        <Table>
          <thead>
            <tr className="hmcSampleId">
              <th>Genista ID</th>
            </tr>
          </thead>
          <tbody>
            {this.addTableRow(data, this.handleRowClick)}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default HmcTable;
